import { STATIC_PATH } from '@shared/constants/ImageConstants';

const AGENCY = 'agency';
const FINAL_USER = 'final_user';

export const UPDATE_SETTINGS_IMG = {
    BACKGROUND: {
        SRC: `${STATIC_PATH}/update_settings/background.png`,
    },
};

export const UPDATE_SETTINGS_TEST_IDS = {
    MODAL: 'update-settings-modal',
    SAVE_BUTTON: 'update-settings-save-button',
    CURRENCY_SELECTOR: 'update-settings-currency-selector',
    ACCOUNT_TYPE_SELECTOR: 'update-settings-account-type-selector',
    TRANSLATION_SELECTOR: 'update-settings-translation-selector',
    ERROR_TOAST: 'update-settings-error-toast',
    SUCCESS_TOAST: 'update-settings-success-toast',
};

export const UPDATE_SETTINGS_TEXTS = {
    ACCOUNT_TYPE: 'Account Type',
    FINAL_USER: 'Final User',
    LANGUAGE: 'Language',
    DEFAULT_CURRENCY: 'Default Currency',
    NUMBER_OF_USERS: 'Users',
    PAGE_TITLE: 'Global Settings',
    PAGE_SUBTITLE: 'Feel free to update anytime you want',
    AGENCY: 'Agency',
};

export const ACCOUNT_TYPES = {
    agency: { label: UPDATE_SETTINGS_TEXTS.AGENCY, value: AGENCY },
    final_user: { label: UPDATE_SETTINGS_TEXTS.FINAL_USER, value: FINAL_USER },
};

export const TOAST_MESSAGES = {
    SUCCESS: 'Changes saved successfully',
    ERROR: 'Unexpected error while saving. Try again later!',
};
